import SocialProjectManager from '../../clients/abdaSocialProjectManager'

const resourceName = 'classschedule'
const resourceClass = 'class'

const GetById = id => SocialProjectManager.get(`${resourceName}/${id}`)
const GetAll = () => SocialProjectManager.get(resourceName)
const GetByClass = classId => SocialProjectManager.get(`${resourceName}/${classId}/${resourceClass}`)

const Create = data => SocialProjectManager.post(resourceName, data)

const Update = data => SocialProjectManager.put(`${resourceName}/${data.id}`, data)

const Delete = id => SocialProjectManager.delete(`${resourceName}/${id}`)

const ClassScheduleRepository = {
  GetById,
  GetAll,
  GetByClass,
  Create,
  Update,
  Delete
}

export default ClassScheduleRepository